import classNames from "classnames";

import { LoadingSpinner } from "../LoadingSpinner";
import { Overlay } from "../Overlay";
import { useStyles } from "./styles";

export const LoadingOverlay: FC<LoadingOverlayProps> = ({ className, isOpen }) => {
  const classes = useStyles();
  return (
    <Overlay className={classNames(classes.loadingOverlay, className)} isOpen={isOpen}>
      <LoadingSpinner />
    </Overlay>
  );
};

type LoadingOverlayProps = {
  isOpen: boolean;
};
